export enum CompanyType {
  Customer = 0,
  Supplier = 1,
  Locations = 2,
  Prospect = 3,
}